import type { Content } from '@plone/types';
import { jsonldFAQ } from '@redturtle/qubicaamf-theme/helpers/jsonldHelpers';
import type { AccordionData } from '@redturtle/qubicaamf-theme/components/Blocks/Accordion/schema';

const faqSchemaOrgHelper = (blocks: Content['blocks']) => {
  if (blocks && Object.keys(blocks).length > 0) {
    const enabledSchemaOrgAccordions = Object.values(blocks).filter(
      (b) => b['@type'] === 'accordion' && b.enable_schema_org,
    ) as AccordionData[];

    const accordionSchemaOrg = enabledSchemaOrgAccordions.map(
      (accordion: AccordionData) => {
        return jsonldFAQ(accordion.items);
      },
    );

    return accordionSchemaOrg;
  }

  return null;
};

export default faqSchemaOrgHelper;
